import { jsx as n } from "react/jsx-runtime";
import { c as r } from "../../index-C3-ZVs5E.js";
import { Spinner as i } from "../spinner/Spinner.component.js";
import { SpinnerThemeEnum as m } from "../spinner/types.js";
import '../../assets/ActionButtons.css';const u = "_actionButtons_1a1nb_2", l = "_button_1a1nb_15", t = {
  actionButtons: u,
  button: l
}, d = ({
  children: o,
  isLoading: s = !1,
  cancelButtonText: e = "",
  submitButtonText: c = "",
  className: a
}) => /* @__PURE__ */ n("div", { className: r(a, t.actionButtons), children: o({
  submitButtonProps: {
    children: s ? /* @__PURE__ */ n(i, { theme: m.negated }) : c,
    className: t.button
  },
  cancelButtonProps: {
    children: e,
    className: t.button
  }
}) });
export {
  d as ActionButtons
};
